
import UserManagementNew from './admin/UserManagement';

export default function UserManagementPage() {
return <UserManagementNew/>
}
